import React, { useState, useEffect } from "react";
import { Table, Space, Form, Flex, message, Tooltip } from "antd";
import { CustomParagraph, AddItemButton, CustomTitle } from "../../components";
import deleteIcon from "../../assets/images/delete.svg";
import editIcon from "../../assets/images/edit-gray-icon.svg";
import invitePlusIcon from "../../assets/images/invite-plus-icon.svg";
import { useNavigate } from "react-router-dom";
import { appHelper, useToken } from "../../common/helper";
import { useSpin } from "../../components/SpinContext";
import { AddUsers, GetUsers } from "../../api's/onboarding";
import TeamBadge from "../../components/TeamBadge";
import {
  GetAllPendingUsers,
} from "../../api's/settings";
import ToggleSwitch from "../../components/ToggleSwitch";
import CustomDeleteModal from "../Modals/CustomDeleteModal";
import CommonDrawer from "../../components/CommonDrawer";
import SettingsInviteUserForm from "./SettingsInviteUserForm";
import InviteUserTable from "./InviteUserTable";
import { useSelector } from "react-redux";
import { getPermissions } from "../../common/helper/getPermissions";




const SettingsUserTable = ({ title }) => {
  const { token, removeToken, decodedUserToken } = useToken();
  let decodedToken = decodedUserToken();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { showSpin, hideSpin } = useSpin();
  const [userList, setUserList] = useState([]);
  const [userID, setUserID] = useState("");
  const [pendingUserList, setPendingUserList] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [deleteData, setDeleteData] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const allTeams = useSelector((state) => state.teams.list);
const isTeamDataLoading = useSelector((state) => state.teams.loading);
  const [showDrawer, setShowDrawer] = useState(false);
  const [is_disable,setIsDisable]= useState(true)
  const {truncateByLength} = appHelper();

    const main_menu = useSelector((state) => state.menu.items);
      const UserPermissions = getPermissions(main_menu, "Settings", "Users");
  

  // Function to handle the toggle action
  const handleToggle = (e) => {
    setIsChecked(e.target.checked);
    const val = e.target.checked;
    fetchAllUsers(val);
  };
  // get all users
  const fetchAllUsers = (getDisabled) => {
    showSpin();
    GetUsers(token, getDisabled)
    .then((res) => {
      const data = res?.data ? res.data : null;
      if (data) {
        if (data?.data?.is_success) {
          // Always set the user list, even if the result is empty
          let arr = data?.data?.data ?? [];
          setUserList(arr);
        } else {
          message.error(data?.data?.message);
        }
      }
    })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };


    const fetchPendingInvitesUsers = () => { 

      showSpin();
      GetAllPendingUsers(token)
        .then((res) => {
          const data = res?.data ? res.data : null;
          if (data) {
            if (data?.data?.is_success) {
              let arr = data?.data?.data.length > 0 ? data?.data?.data : [];
              // if (arr.length > 0) {
                setPendingUserList(arr);
              // }
            } else {
              message.error(data?.data?.message);
            }
          }
        })
        .catch((error) => {
          unauthorize(error);
        })
        .finally(() => {
          hideSpin();
        });
    };

   //get teams for drop down
    // const [allTeams, setAllTeams] = useState([]);
    // useEffect(() => {
    //   getTeamsDDL(token).then((val) => {
    //     if (val && val.length > 0) {
    //       setAllTeams(val);
    //     }
    //   });
    // }, []);

  useEffect(() => {
    fetchAllUsers(false);
    fetchPendingInvitesUsers()
  }, []);

  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  // Users Table actions
  const handleEdit = (record) => {
    setIsDisable(false) 
    // let userId = record?.id ? record.id : "";
    setDeleteData(record);
    setShowDeleteModal(true);
  };

    const handleEditUser = (record) => {
    setIsDisable(false) 
    let userId = record?.id ? record.id : "";
    setDeleteData(record);
    setUserID(userId);
    setShowDrawer(true);
  };

  const handleCloseDrawer = () => {
    setUserID(null);
    setShowDrawer(false);
    form.resetFields();
  };

  // delete user (API pending)
  const handleDelete = (record) => {
    setIsDisable(true)
    setDeleteData(record);
    setShowDeleteModal(true);
  };
  
  const disableUser = (isActive)=>{
    setShowDeleteModal(false);
    if (deleteData && deleteData.id) {
      showSpin();
    let model = { ...deleteData, is_active: isActive };
    model.designation = model?.designation?.id;
    AddUsers(token, model, false)
      .then((res) => {
  
        const data = res?.data || null;
        if (data) {
          if (data.data?.is_success) {
            message.success(data?.data?.message);
            fetchAllUsers(isChecked);

          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
    }
  }
  
  const handleConfirmDelete = () => {
      //is_disable true means its a delete action,
      //so in payload is Active will be false
      disableUser(is_disable===true ?  false : true);
};






const columns = [
  {
    title: "Name / title",
    dataIndex: "name",
    key: "name",
    width: "184px",
    render: (_, record) => (
      <>
        <CustomParagraph
          noText="--"
          text={record?.name}
          fontSize={12}
          fontWeight={600}
          color="#000"
          marginBottom={0}
        />
        <CustomParagraph
          noText="--"
          text={record?.title}
          fontSize={12}
          fontWeight={400}
          color="#5E5E5E"
          marginBottom={0}
        />
      </>
    ),
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    width: "184px",
    render: (text) => (
      <>
      <CustomParagraph
        text={text}
        noText="--"
        fontSize={12}
        fontWeight={400}
        color="#000"
        marginBottom={0}
      />
      </>
    ),
  },
  {
    title: "Phone",
    dataIndex: "phone_number",
    key: "phone_number",
    width: "168px",
    render: (text) => (
      <>
      <CustomParagraph
        text={text}
        noText="--"
        fontSize={12}
        fontWeight={400}
        color="#000"
        marginBottom={0}
      />
      </>
    ),
  },
  {
    title: "Last login",
    dataIndex: "last_login",
    key: "last_login",
    width: "168px",
    render: (text) => {
      const formatDate = (dateString) => {
        if (!dateString) return "--";
        const date = new Date(dateString);
        const options = { month: "short", day: "numeric", year: "numeric" };
        const timeOptions = { hour: "2-digit", minute: "2-digit", hour12: true };
        const formattedDate = date.toLocaleDateString("en-US", options);
        const formattedTime = date.toLocaleTimeString("en-US", timeOptions);
        return `${formattedDate}, ${formattedTime.replace(" ", "").toLowerCase()}`;
      };
  
      return (
        <>
        <CustomParagraph
          text={formatDate(text)}
          noText="--"
          fontSize={12}
          fontWeight={400}
          color="#000"
          marginBottom={0}
        />

        </>
      );
    },
  },
  
  {
    title: "Team: Role",
    dataIndex: "teams",
    key: "teams",
    width: "250px",
    render: (_, record) => {
      return (
        <>
          {record?.is_active ? (
            <>
              {record?.teams?.length > 0 ? (
                <div  style={{
                  display: "flex",
                  gap: "8px",
                  flexWrap: "nowrap",     
                  overflow: "hidden", 
                  whiteSpace: "nowrap",    
                  textOverflow: "ellipsis", 
                }}>
                  <TeamBadge
                    Truncate={false}
                    tooltipText={`${record?.teams[0]?.name}: ${record?.teams[0]?.role_name}`}
                    color={record?.teams[0]?.color}
                    text={`${truncateByLength(record?.teams[0]?.name, 12)}: ${truncateByLength(record?.teams[0]?.role_name, 12)}`}

                  />
                  {record?.teams.length > 1 && (
                    <Tooltip
                      title={record.teams.slice(1).map((team) => `${team.name}: ${team?.role_name}`).join(", ")}
                      placement="top" >
                      <div
                        style={{
                          display: "inline-block",
                          cursor: "pointer",
                        }}
                      >
                        <TeamBadge
                          color={null}
                          text={`+ ${record?.teams.length - 1}`}
                        />
                      </div>
                    </Tooltip>
                  )}
                </div>
              ) : (
                <p>--</p>
              )}
            </>
          ) : (
            <CustomParagraph
              text={"Disabled"}
              noText="--"
              fontSize={12}
              fontWeight={400}
              color="#000"
              marginBottom={0}
            />
          )}
        </>
      );
    },
  },

  // {
  //   title: "Permissions",
  //   dataIndex: "role",
  //   key: "role",
  //   render: (text) => <CustomParagraph text={text} noText='-' fontSize={14} fontWeight={400} color="#000" marginBottom={0} />,
  // },
  {
    title: "",
    dataIndex: "action",
    key: "action",
    render: (text, record) => (
      <>
      <Flex gap={6}>
      
      {record?.permissions?.is_update &&  <Flex
          justify="center"
          align="center"
          style={{ width: "32px", height: "32px", cursor: "pointer" }}
        >
          <img
            src={editIcon}
            alt=""
            title="Edit"
            onClick={() => handleEditUser(record)}
          />
        </Flex>}

        {record?.permissions?.is_delete &&
        <Flex
          justify="center"
          align="center"
          style={{ width: "32px", height: "32px", cursor: "pointer" }}
        >
          {record?.is_active ? (
            <img
              src={deleteIcon}
              alt="Disable"
              title="Disable"
              onClick={() => handleDelete(record)}
            />
          ) : (
            <img
              src={invitePlusIcon}
              alt="invite"
              title="Invite"
              onClick={() => handleEdit(record)}
            />
          )}
        </Flex>}
      </Flex>
      </>
    ),
  },
];

const TeamsFilteredColumns = allTeams?.length > 0 ? columns  : columns.filter((column) => column.key !== "teams");

return (
  <>
    <div className="settings-content-wrapper">
      <Flex wrap style={{ justifyContent: "space-between" }}>
        <CustomTitle
          text={`${title}  (${userList?.length})`}
          fontSize={20}
          fontWeight="700"
          lineHeight="32px"
          color="#000"
          marginBottom={0}
        />

        <ToggleSwitch
          label="Show disabled users"
          checked={isChecked}
          onChange={handleToggle}
        />
      </Flex>
      {/* <Space direction="vertical" size={16}> */}
      <Table
        columns={TeamsFilteredColumns}
        dataSource={userList}
        pagination={false} 
        className="settings-table"
        rowHoverable={false}
      />
      {/* {decodedToken?.role?.toLowerCase() !== "editor" && ( */}
        {UserPermissions?.is_create &&
        <AddItemButton
          marginTop="0px"
          fontSize="12px"
          fontWeight="600"
          text={"Invite user"}
          onClick={() => {
            setShowDrawer(true);
            // navigate("/settings/user/form");
          }}
        />
}
      {/* )} */}
    </div>
    {/* </Space> */}

    {/* pending invite user table  */}
    <InviteUserTable 
    fetchPendingUsers={fetchPendingInvitesUsers}
    pendingUserList={pendingUserList}
    />
    {showDrawer && (
    <CommonDrawer open={showDrawer} onClose={() => handleCloseDrawer()}>
      <SettingsInviteUserForm
        form={form}
        id={userID}
        handleCloseDrawer={handleCloseDrawer}
        handleFetchAllUsers={fetchAllUsers} 
        fetchPendingInvitesUsers={fetchPendingInvitesUsers}
      />
    </CommonDrawer>
    )}
  
    <CustomDeleteModal
      visible={showDeleteModal}
      onClose={() => setShowDeleteModal(false)}
      onConfirm={() => handleConfirmDelete()}
      title={is_disable ? `Disable user` : `Enable user`}
      message={is_disable ? `User will lose access from ZoomLogi and be removed from all notifications.` : `Upon confirmation, the user will be granted access to ZoomLogi and will start receiving notifications.`}
      cancelText={"Cancel"}
      confirmText={is_disable ? "Disable" : "Enable"}
      confirmColor={`#DE1135`}
    />
    
  </>
);
};

export default SettingsUserTable;
